module.exports = __webpack_public_path__ + "static/media/29ADMSPC26.1cf6d57e.jpg";